module.exports = __webpack_public_path__ + "img/kb.e4bb277f.png";